import type {
  Auth,
  NextOrObserver,
  Unsubscribe,
  User,
  UserCredential,
} from "firebase/auth";

const mockUser: User = {
  uid: "mock-user-123",
  email: "test@example.com",
  displayName: "Test User",
  emailVerified: true,
  isAnonymous: false,
  photoURL: null,
  providerData: [],
  refreshToken: "",
  tenantId: "",
  phoneNumber: "",
  providerId: "",
  metadata: {
    creationTime: new Date().toISOString(),
    lastSignInTime: new Date().toISOString(),
  },
  delete: () => Promise.resolve(),
  getIdToken: () => Promise.resolve("mock-token"),
  getIdTokenResult: () =>
    Promise.resolve({
      token: "mock-token",
      authTime: new Date().toISOString(),
      issuedAtTime: new Date().toISOString(),
      expirationTime: new Date(Date.now() + 3600000).toISOString(),
      signInProvider: null,
      claims: {},
      signInSecondFactor: null,
    }),
  reload: () => Promise.resolve(),
  toJSON: () => ({}),
};

const mockUserCredential: UserCredential = {
  user: mockUser,
  providerId: null,
  operationType: "signIn",
};

export class MockAuth implements Partial<Auth> {
  currentUser = mockUser;

  onAuthStateChanged(nextOrObserver: NextOrObserver<User>): Unsubscribe {
    if (typeof nextOrObserver === "function") {
      nextOrObserver(mockUser);
    }

    return () => {};
  }

  async signInWithCustomToken(_token: string): Promise<UserCredential> {
    return Promise.resolve(mockUserCredential);
  }

  async signOut(): Promise<void> {
    return Promise.resolve();
  }
}
